import React, { useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";

const MONO   = "'JetBrains Mono', 'Fira Code', ui-monospace, monospace";
const ACCENT = "#E2684A";
const BG     = "#030014";
const LINE   = "#1E2130";
const INK    = "#E7E9EE";
const INK2   = "#B6BBC6";

const FAQAccordion = ({ title, subtitle, faqs }) => {
  const [open, setOpen] = useState(null);

  return (
    <Box sx={{ py: { xs: 10, md: 13 }, borderBottom: `1px solid ${LINE}`, background: BG }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
          viewport={{ once: true }}
        >
          <Typography sx={{ fontFamily: MONO, fontSize: "12px", letterSpacing: "0.16em", textTransform: "uppercase", color: ACCENT, mb: 1.75 }}>
            {subtitle || "FAQ"}
          </Typography>
          <Typography sx={{
            fontFamily: "'IBM Plex Serif', serif",
            fontSize: { xs: "1.75rem", md: "2.5rem" },
            fontWeight: 600, letterSpacing: "-0.015em", lineHeight: 1.15,
            color: INK, maxWidth: 600, mb: 4,
          }}>
            {title || "Frequently Asked Questions"}
          </Typography>
        </motion.div>

        <Box>
          {faqs.map((faq, i) => (
            <Box key={i} sx={{ borderTop: `1px solid ${LINE}`, "&:last-child": { borderBottom: `1px solid ${LINE}` } }}>
              <Box
                onClick={() => setOpen(open === i ? null : i)}
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 2.5, px: 0.5, cursor: "pointer" }}
              >
                <Typography sx={{
                  fontSize: { xs: "15.5px", md: "17px" }, fontWeight: 500, pr: 2, lineHeight: 1.4,
                  color: open === i ? INK : "#C5CAD4", transition: "color 0.15s",
                }}>
                  {faq.question}
                </Typography>
                <Box sx={{ fontFamily: MONO, color: ACCENT, fontSize: "22px", flexShrink: 0, lineHeight: 1, userSelect: "none" }}>
                  {open === i ? "−" : "+"}
                </Box>
              </Box>
              {open === i && (
                <Box sx={{ pb: 2.5, px: 0.5 }}>
                  <Typography sx={{ color: INK2, fontSize: "15.5px", lineHeight: 1.75, maxWidth: 720 }}>
                    {faq.answer}
                  </Typography>
                </Box>
              )}
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FAQAccordion;
